import React from 'react';

function TermsPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Terms of Service</h1>
        <p>Last updated: March 2026</p>
      </div>

      <div className="page-content">
        <h2>Agreement to Terms</h2>
        <p>
          By downloading, installing, accessing, or using any of Music4Fun LLC's applications, services, or websites (collectively, the "Service"), you agree to be bound by these Terms of Service. If you do not agree to abide by the above, please do not use this service.
        </p>

        <h2>Use License</h2>
        <p>
          Permission is granted to temporarily download one copy of the materials (information or software) from our Service for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
        </p>
        <ul>
          <li>Modifying or copying the materials</li>
          <li>Using the materials for any commercial purpose or for any public display</li>
          <li>Attempting to decompile or reverse engineer any software contained on the Service</li>
          <li>Removing any copyright or other proprietary notations from the materials</li>
          <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
          <li>Unlawfully accessing or attempting to gain unauthorized access to our systems</li>
        </ul>

        <h2>Disclaimer</h2>
        <p>
          The materials on Music4Fun LLC's Service are provided on an 'as is' basis. Music4Fun LLC makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </p>

        <h2>Limitations</h2>
        <p>
          In no event shall Music4Fun LLC or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Music4Fun LLC's Service, even if Music4Fun LLC or an authorized representative has been notified orally or in writing of the possibility of such damage.
        </p>

        <h2>Accuracy of Materials</h2>
        <p>
          The materials appearing on Music4Fun LLC's Service could include technical, typographical, or photographic errors. Music4Fun LLC does not warrant that any of the materials on its Service are accurate, complete, or current. Music4Fun LLC may make changes to the materials contained on its Service at any time without notice.
        </p>

        <h2>Links</h2>
        <p>
          Music4Fun LLC has not reviewed all of the sites linked to its Service and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Music4Fun LLC of the site. Use of any such linked website is at the user's own risk.
        </p>

        <h2>Modifications</h2>
        <p>
          Music4Fun LLC may revise these Terms of Service for its Service at any time without notice. By using this Service, you are agreeing to be bound by the then current version of these Terms of Service.
        </p>

        <h2>Governing Law</h2>
        <p>
          These terms and conditions are governed by and construed in accordance with the laws of the State of Texas, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
        </p>

        <h2>Account Termination</h2>
        <p>
          Music4Fun LLC reserves the right to terminate your access to the Service at any time, for any reason, including violation of these Terms of Service or any applicable laws.
        </p>

        <h2>User Conduct</h2>
        <p>
          You agree not to use the Service in any way that violates any applicable law or regulation, or that infringes upon the rights of others, or that could damage, disable, or impair the Service.
        </p>
      </div>
    </div>
  );
}

export default TermsPage;
